import React from 'react';
import { FDStack } from '@facet-wealth/design';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { GoalDetailHeader } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalDetail/GoalDetailHeader';
import {
  SaveForRetirementStepBody,
} from 'Views/Page/Content/Modal/Layouts/SaveForRetirementStep/SaveForRetirementStepBody';

const SaveForRetirementLayout = () => {
  const {
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();
  return (
    <FDStack direction="column" spacing={2} alignItems="center" width={'100%'}>
      <GoalDetailHeader />
      <SaveForRetirementStepBody />
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
      />
    </FDStack>
  );
};

SaveForRetirementLayout.defaultProps = {};

SaveForRetirementLayout.propTypes = {};

export { SaveForRetirementLayout };
